import React, { useState, Component } from 'react';
import { ArrowLeftIcon, MapPinIcon, EditIcon, CompassIcon, PackageIcon, TruckIcon, BarChart3Icon, BoxIcon, ClipboardListIcon, HistoryIcon, CalendarIcon, AlertCircleIcon, CheckCircleIcon, SearchIcon, FilterIcon, PlusIcon, DownloadIcon, RefreshCwIcon, ChevronDownIcon, ChevronRightIcon, SettingsIcon, UserIcon, ArrowRightIcon, PieChartIcon, EyeIcon, TrashIcon, XCircleIcon, InfoIcon, SlidersIcon, ArrowUpDownIcon, CheckIcon, ListFilterIcon, ShieldIcon, TrendingUpIcon, TrendingDownIcon, ThumbsUpIcon, ThumbsDownIcon, PercentIcon, PrinterIcon, ArchiveIcon, HelpCircleIcon, BellIcon, FileTextIcon, TagIcon, ZapIcon } from 'lucide-react';
export function WarehouseDetails({
  id = 'IU1',
  name = 'Pierce - San Antonio',
  location = '6203 Woodlake Center TEXAS San Antonio United States',
  flag = '🇺🇸',
  stock = '2%',
  machines = '7',
  onBack
}) {
  const [activeTab, setActiveTab] = useState('details');
  const [activeStockTab, setActiveStockTab] = useState('stockByDesign');
  const [stockFilter, setStockFilter] = useState('all');
  const [stockSort, setStockSort] = useState('name');
  const [showStockTemplateModal, setShowStockTemplateModal] = useState(false);
  const [showFilterPanel, setShowFilterPanel] = useState(false);
  // Mock data for the warehouse details
  const warehouseData = {
    oracleCode: id,
    organizationId: '9946',
    name: location.split(' ').pop(),
    region: 'Aisco AMERICA',
    address: location,
    zipCode: '78244',
    coordinates: '29.485804, -98.360062'
  };
  // Mock data for machine stock
  const machineStockData = [{
    id: 'M001',
    name: '6" 5/8 GALV',
    type: 'Pivot Machine',
    desiredStock: 100,
    stats: {
      lowStock: 1,
      overStock: 90,
      covered: 7,
      orderRequired: 2
    },
    atHand: 0,
    incoming: 0,
    lastUpdated: '2023-10-15',
    status: 'Critical',
    priority: 'High',
    category: 'Irrigation',
    trend: 'decreasing',
    forecast: 'Needs restock within 7 days'
  }, {
    id: 'M002',
    name: '8" 5/8 GALV',
    type: 'Pivot Machine',
    desiredStock: 30,
    stats: {
      lowStock: 0,
      overStock: 80,
      covered: 20,
      orderRequired: 0
    },
    atHand: 7,
    incoming: 21,
    lastUpdated: '2023-10-18',
    status: 'Good',
    priority: 'Medium',
    category: 'Irrigation',
    trend: 'stable',
    forecast: 'Stock levels adequate for 30 days'
  }, {
    id: 'M003',
    name: '5" GALV',
    type: 'Pivot Machine',
    desiredStock: 20,
    stats: {
      lowStock: 4,
      overStock: 71,
      covered: 15,
      orderRequired: 10
    },
    atHand: 0,
    incoming: 5,
    lastUpdated: '2023-10-12',
    status: 'Warning',
    priority: 'Medium',
    category: 'Irrigation',
    trend: 'increasing',
    forecast: 'Incoming shipment will improve levels'
  }, {
    id: 'M004',
    name: 'High Profile',
    type: 'Pivot Machine',
    desiredStock: 20,
    stats: {
      lowStock: 0,
      overStock: 99,
      covered: 1,
      orderRequired: 0
    },
    atHand: 0,
    incoming: 0,
    lastUpdated: '2023-10-05',
    status: 'Critical',
    priority: 'Low',
    category: 'Specialized',
    trend: 'stable',
    forecast: 'Low demand, no immediate action needed'
  }, {
    id: 'M005',
    name: 'Linear',
    type: 'Linear',
    desiredStock: 15,
    stats: {
      lowStock: 17,
      overStock: 8,
      covered: 65,
      orderRequired: 10
    },
    atHand: 1,
    incoming: 0,
    lastUpdated: '2023-10-19',
    status: 'Warning',
    priority: 'High',
    category: 'Linear Systems',
    trend: 'decreasing',
    forecast: 'Order required within 14 days'
  }, {
    id: 'M006',
    name: 'Corner Arm',
    type: 'Pivot Accessory',
    desiredStock: 8,
    stats: {
      lowStock: 0,
      overStock: 0,
      covered: 100,
      orderRequired: 0
    },
    atHand: 8,
    incoming: 2,
    lastUpdated: '2023-10-17',
    status: 'Optimal',
    priority: 'Low',
    category: 'Accessories',
    trend: 'increasing',
    forecast: 'Stock levels optimal'
  }];
  // Consolidated stock data
  const consolidatedStock = {
    name: 'Stock Consolidated',
    stats: {
      lowStock: 2,
      overStock: 85,
      covered: 6,
      orderRequired: 7
    },
    percentage: '2%',
    atHand: 7,
    incoming: 21,
    trend: {
      weekly: '+2%',
      monthly: '-5%',
      quarterly: '+12%'
    },
    healthScore: 68,
    alertCount: 3,
    lastUpdated: '2023-10-20'
  };
  // Filter and sort machines based on current selections
  const getFilteredAndSortedMachines = () => {
    let filtered = [...machineStockData];
    // Apply filters
    if (stockFilter === 'critical') {
      filtered = filtered.filter(m => m.status === 'Critical');
    } else if (stockFilter === 'warning') {
      filtered = filtered.filter(m => m.status === 'Warning');
    } else if (stockFilter === 'good') {
      filtered = filtered.filter(m => m.status === 'Good' || m.status === 'Optimal');
    } else if (stockFilter === 'incoming') {
      filtered = filtered.filter(m => m.incoming > 0);
    } else if (stockFilter === 'nostock') {
      filtered = filtered.filter(m => m.atHand === 0);
    }
    // Apply sorting
    if (stockSort === 'name') {
      filtered.sort((a, b) => a.name.localeCompare(b.name));
    } else if (stockSort === 'priority') {
      const priorityOrder = {
        High: 0,
        Medium: 1,
        Low: 2
      };
      filtered.sort((a, b) => priorityOrder[a.priority] - priorityOrder[b.priority]);
    } else if (stockSort === 'status') {
      const statusOrder = {
        Critical: 0,
        Warning: 1,
        Good: 2,
        Optimal: 3
      };
      filtered.sort((a, b) => statusOrder[a.status] - statusOrder[b.status]);
    } else if (stockSort === 'stock') {
      filtered.sort((a, b) => b.atHand - a.atHand);
    }
    return filtered;
  };
  // Get status counts for summary
  const getStatusCounts = () => {
    const counts = {
      critical: machineStockData.filter(m => m.status === 'Critical').length,
      warning: machineStockData.filter(m => m.status === 'Warning').length,
      good: machineStockData.filter(m => m.status === 'Good').length,
      optimal: machineStockData.filter(m => m.status === 'Optimal').length
    };
    return counts;
  };
  const statusCounts = getStatusCounts();
  const filteredMachines = getFilteredAndSortedMachines();
  // Mock data for inventory
  const inventoryData = [{
    category: 'Irrigation Parts',
    items: [{
      id: 'IP001',
      name: 'Sprinkler Head Type A',
      quantity: 120,
      unit: 'pcs',
      status: 'Optimal'
    }, {
      id: 'IP002',
      name: 'Pipe Connector 2"',
      quantity: 85,
      unit: 'pcs',
      status: 'Optimal'
    }, {
      id: 'IP003',
      name: 'Valve System B',
      quantity: 12,
      unit: 'sets',
      status: 'Low'
    }]
  }, {
    category: 'Electronic Components',
    items: [{
      id: 'EC001',
      name: 'Control Board v2',
      quantity: 8,
      unit: 'pcs',
      status: 'Low'
    }, {
      id: 'EC002',
      name: 'Sensor Package',
      quantity: 24,
      unit: 'pcs',
      status: 'Optimal'
    }]
  }, {
    category: 'Structural Elements',
    items: [{
      id: 'SE001',
      name: 'Support Beam 4m',
      quantity: 0,
      unit: 'pcs',
      status: 'Out of Stock'
    }, {
      id: 'SE002',
      name: 'Tower Section',
      quantity: 6,
      unit: 'sets',
      status: 'Low'
    }]
  }];
  // Mock data for alterations
  const alterationsData = [{
    id: 'ALT001',
    date: '2023-10-20',
    type: 'Stock Update',
    description: 'Added 4 Control Panel Pro units',
    user: 'Maria Rodriguez'
  }, {
    id: 'ALT002',
    date: '2023-10-18',
    type: 'Inventory Adjustment',
    description: 'Corrected Sprinkler Head Type A count from 110 to 120',
    user: 'John Smith'
  }, {
    id: 'ALT003',
    date: '2023-10-15',
    type: 'Machine Removal',
    description: 'Removed 1 Linear System A for maintenance',
    user: 'David Chen'
  }, {
    id: 'ALT004',
    date: '2023-10-10',
    type: 'Address Update',
    description: 'Updated warehouse zip code',
    user: 'Sarah Johnson'
  }, {
    id: 'ALT005',
    date: '2023-10-05',
    type: 'Stock Update',
    description: 'Received new shipment of Sensor Packages (24 units)',
    user: 'Maria Rodriguez'
  }];
  return <div className="bg-gradient-to-r from-blue-950 via-indigo-900 to-teal-900 min-h-screen text-white" data-id="element-6523">
      {/* Header with enhanced styling */}
      <div className="p-5 flex items-center bg-gradient-to-r from-blue-900/80 to-indigo-900/80 backdrop-blur-sm shadow-md" data-id="element-6524">
        <button onClick={onBack} className="mr-4 p-2 text-white bg-gradient-to-br from-white/20 to-white/5 hover:from-white/30 hover:to-white/10 rounded-full transition-all duration-300 shadow-lg" data-id="element-6525">
          <ArrowLeftIcon size={20} data-id="element-6526" />
        </button>
        <div data-id="element-6527">
          <div className="flex items-center" data-id="element-6528">
            <h1 className="text-2xl font-bold" data-id="element-6529">{name}</h1>
            <span className="ml-2 text-2xl" data-id="element-6530">{flag}</span>
          </div>
          <div className="flex items-center text-blue-100 text-sm mt-1" data-id="element-6531">
            <span className="bg-gradient-to-r from-blue-800/70 to-indigo-800/70 px-2 py-0.5 rounded-md" data-id="element-6532">
              {id}
            </span>
            <span className="mx-2" data-id="element-6533">|</span>
            <MapPinIcon size={14} className="mr-1" data-id="element-6534" />
            <span data-id="element-6535">{location}</span>
          </div>
        </div>
      </div>
      {/* Tabs with enhanced styling */}
      <div className="border-b border-indigo-800 bg-gradient-to-r from-blue-900/40 to-indigo-900/40 backdrop-blur-sm" data-id="element-6536">
        <div className="flex px-4" data-id="element-6537">
          <TabButton icon={<ClipboardListIcon size={18} data-id="element-6539" />} label="Details" active={activeTab === 'details'} onClick={() => setActiveTab('details')} data-id="element-6538" />
          <TabButton icon={<PackageIcon size={18} data-id="element-6541" />} label="Machine Stock" active={activeTab === 'machineStock'} onClick={() => setActiveTab('machineStock')} data-id="element-6540" />
          <TabButton icon={<BoxIcon size={18} data-id="element-6543" />} label="Inventory" active={activeTab === 'inventory'} onClick={() => setActiveTab('inventory')} data-id="element-6542" />
          <TabButton icon={<HistoryIcon size={18} data-id="element-6545" />} label="Alterations" active={activeTab === 'alterations'} onClick={() => setActiveTab('alterations')} data-id="element-6544" />
        </div>
      </div>
      {/* Content with improved spacing */}
      <div className="p-6 md:p-8" data-id="element-6546">
        {activeTab === 'details' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6547">
            <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6548">
              <h2 className="text-xl font-bold flex items-center text-indigo-800" data-id="element-6549">
                <ClipboardListIcon size={22} className="mr-3 text-indigo-600" data-id="element-6550" />
                Warehouse Details
              </h2>
            </div>
            <div className="p-6 md:p-8" data-id="element-6551">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-6552">
                <div className="space-y-6" data-id="element-6553">
                  <DetailRow icon={<BoxIcon size={18} className="text-indigo-600" data-id="element-6555" />} label="Oracle Code:" value={warehouseData.oracleCode} data-id="element-6554" />
                  <DetailRow icon={<BarChart3Icon size={18} className="text-indigo-600" data-id="element-6557" />} label="Organization ID:" value={warehouseData.organizationId} data-id="element-6556" />
                  <DetailRow icon={<MapPinIcon size={18} className="text-indigo-600" data-id="element-6559" />} label="Name:" value={warehouseData.name} data-id="element-6558" />
                  <DetailRow icon={<TruckIcon size={18} className="text-indigo-600" data-id="element-6561" />} label="Region:" value={warehouseData.region} data-id="element-6560" />
                </div>
                <div className="space-y-6" data-id="element-6562">
                  <DetailRow icon={<MapPinIcon size={18} className="text-indigo-600" data-id="element-6564" />} label="Address:" value={warehouseData.address} data-id="element-6563" />
                  <DetailRow icon={<MapPinIcon size={18} className="text-indigo-600" data-id="element-6566" />} label="Zip Code:" value={warehouseData.zipCode} data-id="element-6565" />
                  <DetailRow icon={<CompassIcon size={18} className="text-indigo-600" data-id="element-6568" />} label="Coordinates:" value={warehouseData.coordinates} data-id="element-6567" />
                </div>
              </div>
              {/* Map placeholder with improved styling */}
              <div className="mt-8 bg-gradient-to-b from-blue-50 via-indigo-50 to-gray-50 rounded-xl p-6 h-64 flex items-center justify-center shadow-inner" data-id="element-6569">
                <div className="text-center" data-id="element-6570">
                  <div className="bg-gradient-to-br from-white to-blue-50 p-4 rounded-full shadow-md inline-block mb-4" data-id="element-6571">
                    <CompassIcon size={40} className="text-indigo-500" data-id="element-6572" />
                  </div>
                  <p className="text-gray-600 font-medium" data-id="element-6573">
                    Interactive map would be displayed here
                  </p>
                  <p className="text-sm text-gray-500 mt-2 flex items-center justify-center" data-id="element-6574">
                    <MapPinIcon size={14} className="mr-1" data-id="element-6575" />
                    {warehouseData.coordinates}
                  </p>
                </div>
              </div>
            </div>
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-8 py-5 flex justify-end" data-id="element-6576">
              <button className="flex items-center text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 px-5 py-2.5 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg" data-id="element-6577">
                <EditIcon size={16} className="mr-2" data-id="element-6578" />
                Edit Warehouse Details
              </button>
            </div>
          </div>}
        {activeTab === 'machineStock' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6579">
            {/* Sub-tabs navigation with improved styling */}
            <div className="border-b border-gray-200 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6580">
              <div className="flex" data-id="element-6581">
                <StockTabButton label="Stock By Design" active={activeStockTab === 'stockByDesign'} onClick={() => setActiveStockTab('stockByDesign')} data-id="element-6582" />
                <StockTabButton label="Stock in transit" active={activeStockTab === 'stockInTransit'} onClick={() => setActiveStockTab('stockInTransit')} data-id="element-6583" />
                <button className="px-5 py-3.5 text-gray-600 hover:text-gray-800 flex items-center transition-colors" data-id="element-6584">
                  <SettingsIcon size={16} className="mr-2" data-id="element-6585" />
                  Settings
                </button>
              </div>
            </div>
            {activeStockTab === 'stockByDesign' && <>
                {/* Enhanced dashboard header with improved styling */}
                <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-white to-blue-50" data-id="element-6586">
                  <div className="flex flex-col md:flex-row md:items-center justify-between gap-4" data-id="element-6587">
                    <div data-id="element-6588">
                      <h2 className="text-xl font-bold text-gray-800 flex items-center" data-id="element-6589">
                        <PackageIcon size={22} className="mr-2 text-indigo-600" data-id="element-6590" />
                        Machine Stock Management
                      </h2>
                      <p className="text-gray-600 mt-1" data-id="element-6591">
                        Monitor and manage machine stock levels across your
                        warehouse
                      </p>
                    </div>
                    <div className="flex flex-wrap gap-3" data-id="element-6592">
                      <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" onClick={() => setShowFilterPanel(!showFilterPanel)} data-id="element-6593">
                        <FilterIcon size={16} className="mr-2" data-id="element-6594" />
                        Filter
                        <span className={`ml-1 flex items-center justify-center h-5 w-5 text-xs rounded-full ${stockFilter !== 'all' ? 'bg-indigo-100 text-indigo-700' : 'bg-gray-100 text-gray-500'}`} data-id="element-6595">
                          {stockFilter !== 'all' ? '1' : '0'}
                        </span>
                      </button>
                      <div className="relative group" data-id="element-6596">
                        <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6597">
                          <ArrowUpDownIcon size={16} className="mr-2" data-id="element-6598" />
                          Sort By
                          <ChevronDownIcon size={16} className="ml-2" data-id="element-6599" />
                        </button>
                        <div className="absolute right-0 mt-2 w-48 bg-white rounded-lg shadow-lg border border-gray-200 opacity-0 invisible group-hover:opacity-100 group-hover:visible transition-all z-10" data-id="element-6600">
                          <div className="py-1" data-id="element-6601">
                            <SortOption label="Name" active={stockSort === 'name'} onClick={() => setStockSort('name')} data-id="element-6602" />
                            <SortOption label="Priority" active={stockSort === 'priority'} onClick={() => setStockSort('priority')} data-id="element-6603" />
                            <SortOption label="Status" active={stockSort === 'status'} onClick={() => setStockSort('status')} data-id="element-6604" />
                            <SortOption label="Stock Level" active={stockSort === 'stock'} onClick={() => setStockSort('stock')} data-id="element-6605" />
                          </div>
                        </div>
                      </div>
                      <button className="flex items-center text-white bg-gradient-to-r from-blue-500 to-indigo-600 hover:from-blue-600 hover:to-indigo-700 px-4 py-2 rounded-lg transition-all shadow-md hover:shadow-lg" onClick={() => setShowStockTemplateModal(true)} data-id="element-6606">
                        <PlusIcon size={16} className="mr-2" data-id="element-6607" />
                        Create Template
                      </button>
                      <button className="flex items-center text-gray-700 border border-gray-300 px-3 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6608">
                        <DownloadIcon size={16} data-id="element-6609" />
                      </button>
                      <button className="flex items-center text-gray-700 border border-gray-300 px-3 py-2 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6610">
                        <PrinterIcon size={16} data-id="element-6611" />
                      </button>
                    </div>
                  </div>
                  {/* Filter panel */}
                  {showFilterPanel && <div className="mt-4 p-4 bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg border border-blue-100 animate-fadeIn" data-id="element-6612">
                      <div className="flex items-center justify-between mb-3" data-id="element-6613">
                        <h3 className="font-medium text-indigo-800 flex items-center" data-id="element-6614">
                          <ListFilterIcon size={16} className="mr-2" data-id="element-6615" />
                          Filter Machine Stock
                        </h3>
                        <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowFilterPanel(false)} data-id="element-6616">
                          <XCircleIcon size={18} data-id="element-6617" />
                        </button>
                      </div>
                      <div className="grid grid-cols-2 md:grid-cols-5 gap-3" data-id="element-6618">
                        <FilterButton label="All Machines" active={stockFilter === 'all'} onClick={() => setStockFilter('all')} count={machineStockData.length} data-id="element-6619" />
                        <FilterButton label="Critical Stock" active={stockFilter === 'critical'} onClick={() => setStockFilter('critical')} count={statusCounts.critical} color="red" data-id="element-6620" />
                        <FilterButton label="Warning Stock" active={stockFilter === 'warning'} onClick={() => setStockFilter('warning')} count={statusCounts.warning} color="amber" data-id="element-6621" />
                        <FilterButton label="Good Stock" active={stockFilter === 'good'} onClick={() => setStockFilter('good')} count={statusCounts.good + statusCounts.optimal} color="green" data-id="element-6622" />
                        <FilterButton label="Incoming" active={stockFilter === 'incoming'} onClick={() => setStockFilter('incoming')} count={machineStockData.filter(m => m.incoming > 0).length} color="blue" data-id="element-6623" />
                        <FilterButton label="No Stock" active={stockFilter === 'nostock'} onClick={() => setStockFilter('nostock')} count={machineStockData.filter(m => m.atHand === 0).length} color="gray" data-id="element-6624" />
                      </div>
                    </div>}
                </div>
                {/* Summary cards row */}
                <div className="p-6 grid grid-cols-1 md:grid-cols-4 gap-4 bg-gradient-to-br from-white to-blue-50" data-id="element-6625">
                  <div className="bg-gradient-to-br from-indigo-50 to-blue-100 rounded-xl p-4 border border-blue-200 shadow-md" data-id="element-6626">
                    <div className="flex items-center justify-between" data-id="element-6627">
                      <div data-id="element-6628">
                        <p className="text-sm font-medium text-indigo-800" data-id="element-6629">
                          Overall Stock Health
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-indigo-900" data-id="element-6630">
                          {consolidatedStock.healthScore}
                          <span className="text-sm font-normal text-indigo-700" data-id="element-6631">
                            /100
                          </span>
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-indigo-400 to-blue-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6632">
                        <ShieldIcon size={24} className="text-white" data-id="element-6633" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm" data-id="element-6634">
                      <span className={`flex items-center ${consolidatedStock.trend.weekly.startsWith('+') ? 'text-green-700' : 'text-red-700'}`} data-id="element-6635">
                        {consolidatedStock.trend.weekly.startsWith('+') ? <TrendingUpIcon size={14} className="mr-1" data-id="element-6636" /> : <TrendingDownIcon size={14} className="mr-1" data-id="element-6637" />}
                        {consolidatedStock.trend.weekly} this week
                      </span>
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-red-50 to-rose-100 rounded-xl p-4 border border-red-200 shadow-md" data-id="element-6638">
                    <div className="flex items-center justify-between" data-id="element-6639">
                      <div data-id="element-6640">
                        <p className="text-sm font-medium text-red-800" data-id="element-6641">
                          Critical Stock
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-red-900" data-id="element-6642">
                          {statusCounts.critical}
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-red-400 to-rose-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6643">
                        <AlertCircleIcon size={24} className="text-white" data-id="element-6644" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm text-red-800" data-id="element-6645">
                      <ThumbsDownIcon size={14} className="mr-1" data-id="element-6646" />
                      Needs immediate attention
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-green-50 to-emerald-100 rounded-xl p-4 border border-green-200 shadow-md" data-id="element-6647">
                    <div className="flex items-center justify-between" data-id="element-6648">
                      <div data-id="element-6649">
                        <p className="text-sm font-medium text-green-800" data-id="element-6650">
                          Optimal Stock
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-green-900" data-id="element-6651">
                          {statusCounts.optimal}
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-green-400 to-emerald-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6652">
                        <CheckCircleIcon size={24} className="text-white" data-id="element-6653" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm text-green-800" data-id="element-6654">
                      <ThumbsUpIcon size={14} className="mr-1" data-id="element-6655" />
                      Well-stocked machines
                    </div>
                  </div>
                  <div className="bg-gradient-to-br from-amber-50 to-yellow-100 rounded-xl p-4 border border-amber-200 shadow-md" data-id="element-6656">
                    <div className="flex items-center justify-between" data-id="element-6657">
                      <div data-id="element-6658">
                        <p className="text-sm font-medium text-amber-800" data-id="element-6659">
                          Incoming Shipments
                        </p>
                        <h3 className="mt-1 text-2xl font-bold text-amber-900" data-id="element-6660">
                          {machineStockData.filter(m => m.incoming > 0).length}
                        </h3>
                      </div>
                      <div className="h-12 w-12 bg-gradient-to-br from-amber-400 to-yellow-500 rounded-full flex items-center justify-center shadow-md" data-id="element-6661">
                        <TruckIcon size={24} className="text-white" data-id="element-6662" />
                      </div>
                    </div>
                    <div className="mt-3 flex items-center text-sm text-amber-800" data-id="element-6663">
                      <CalendarIcon size={14} className="mr-1" data-id="element-6664" />
                      Next arrival: 3 days
                    </div>
                  </div>
                </div>
                {/* Consolidated stock card - enhanced */}
                <div className="px-6 pt-2 pb-6 bg-gradient-to-br from-white to-blue-50" data-id="element-6665">
                  <div className="bg-gradient-to-br from-white via-blue-50 to-indigo-100 border border-blue-200 rounded-xl overflow-hidden shadow-lg" data-id="element-6666">
                    <div className="p-5 border-b border-blue-100" data-id="element-6667">
                      <div className="flex justify-between items-start" data-id="element-6668">
                        <div data-id="element-6669">
                          <div className="flex items-center" data-id="element-6670">
                            <h3 className="font-bold text-xl text-indigo-800" data-id="element-6671">
                              {consolidatedStock.name}
                            </h3>
                            <span className="ml-3 bg-gradient-to-r from-blue-100 to-indigo-100 text-indigo-700 text-xs px-2.5 py-0.5 rounded-full" data-id="element-6672">
                              Last updated: {consolidatedStock.lastUpdated}
                            </span>
                          </div>
                          <p className="text-gray-600 mt-1" data-id="element-6673">
                            Comprehensive overview of all machine stock in this
                            warehouse
                          </p>
                        </div>
                        <div className="bg-gradient-to-br from-blue-100 to-indigo-200 p-2 rounded-full" data-id="element-6674">
                          <PieChartIcon size={24} className="text-indigo-600" data-id="element-6675" />
                        </div>
                      </div>
                      <div className="mt-5 grid grid-cols-1 md:grid-cols-4 gap-4" data-id="element-6676">
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6677">
                          <div className="flex items-center justify-between" data-id="element-6678">
                            <div data-id="element-6679">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6680">
                                Total Machines
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-gray-800" data-id="element-6681">
                                {machineStockData.length}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-gray-100 to-gray-200 rounded-full flex items-center justify-center" data-id="element-6682">
                              <PackageIcon size={20} className="text-gray-700" data-id="element-6683" />
                            </div>
                          </div>
                        </div>
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6684">
                          <div className="flex items-center justify-between" data-id="element-6685">
                            <div data-id="element-6686">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6687">
                                Machines at Hand
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-indigo-700" data-id="element-6688">
                                {consolidatedStock.atHand}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-indigo-100 to-blue-200 rounded-full flex items-center justify-center" data-id="element-6689">
                              <BoxIcon size={20} className="text-indigo-700" data-id="element-6690" />
                            </div>
                          </div>
                        </div>
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6691">
                          <div className="flex items-center justify-between" data-id="element-6692">
                            <div data-id="element-6693">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6694">
                                Incoming Machines
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-teal-600" data-id="element-6695">
                                {consolidatedStock.incoming}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-teal-100 to-green-200 rounded-full flex items-center justify-center" data-id="element-6696">
                              <TruckIcon size={20} className="text-teal-700" data-id="element-6697" />
                            </div>
                          </div>
                        </div>
                        <div className="bg-gradient-to-br from-white to-gray-50 rounded-lg p-4 border border-gray-100 shadow-sm" data-id="element-6698">
                          <div className="flex items-center justify-between" data-id="element-6699">
                            <div data-id="element-6700">
                              <p className="text-sm font-medium text-gray-500" data-id="element-6701">
                                Alerts
                              </p>
                              <h4 className="mt-1 text-xl font-bold text-amber-600" data-id="element-6702">
                                {consolidatedStock.alertCount}
                              </h4>
                            </div>
                            <div className="h-10 w-10 bg-gradient-to-br from-amber-100 to-orange-200 rounded-full flex items-center justify-center" data-id="element-6703">
                              <BellIcon size={20} className="text-amber-700" data-id="element-6704" />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="p-5" data-id="element-6705">
                      <div className="flex justify-between items-start mb-6" data-id="element-6706">
                        <div className="space-y-4 w-full max-w-md" data-id="element-6707">
                          <h4 className="font-medium text-gray-800" data-id="element-6708">
                            Stock Distribution
                          </h4>
                          <div className="space-y-3" data-id="element-6709">
                            <StockStatItemEnhanced color="yellow" label="Low Stock" value={`${consolidatedStock.stats.lowStock}%`} icon={<AlertCircleIcon size={14} data-id="element-6711" />} data-id="element-6710" />
                            <StockStatItemEnhanced color="orange" label="Over Stock" value={`${consolidatedStock.stats.overStock}%`} icon={<PercentIcon size={14} data-id="element-6713" />} data-id="element-6712" />
                            <StockStatItemEnhanced color="green" label="Covered" value={`${consolidatedStock.stats.covered}%`} icon={<CheckIcon size={14} data-id="element-6715" />} data-id="element-6714" />
                            <StockStatItemEnhanced color="red" label="Order Required" value={`${consolidatedStock.stats.orderRequired}%`} icon={<ShoppingCartIcon size={14} className="text-indigo-600" data-id="element-6717" />} data-id="element-6716" />
                          </div>
                        </div>
                        <div className="text-center" data-id="element-6718">
                          <div className="relative" data-id="element-6719">
                            <div className="w-32 h-32 rounded-full flex items-center justify-center bg-gradient-to-br from-blue-100 to-indigo-200 border-4 border-indigo-200 shadow-md" data-id="element-6720">
                              <div className="text-center" data-id="element-6721">
                                <span className="text-4xl font-bold text-indigo-800" data-id="element-6722">
                                  {consolidatedStock.percentage}
                                </span>
                                <p className="text-xs font-medium text-indigo-600 mt-1" data-id="element-6723">
                                  Overall Stock
                                </p>
                              </div>
                            </div>
                            <div className="absolute -bottom-2 -right-2 bg-gradient-to-r from-blue-500 to-indigo-600 text-white text-xs px-2.5 py-1 rounded-full shadow-md" data-id="element-6724">
                              <ZapIcon size={14} className="inline mr-1" data-id="element-6725" />
                              Status
                            </div>
                          </div>
                          <div className="mt-4 grid grid-cols-3 gap-2 text-xs" data-id="element-6726">
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-100 rounded-lg p-2" data-id="element-6727">
                              <div className="font-medium text-indigo-800" data-id="element-6728">
                                Weekly
                              </div>
                              <div className={`font-bold ${consolidatedStock.trend.weekly.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-6729">
                                {consolidatedStock.trend.weekly}
                              </div>
                            </div>
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-100 rounded-lg p-2" data-id="element-6730">
                              <div className="font-medium text-indigo-800" data-id="element-6731">
                                Monthly
                              </div>
                              <div className={`font-bold ${consolidatedStock.trend.monthly.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-6732">
                                {consolidatedStock.trend.monthly}
                              </div>
                            </div>
                            <div className="bg-gradient-to-r from-blue-50 to-indigo-100 rounded-lg p-2" data-id="element-6733">
                              <div className="font-medium text-indigo-800" data-id="element-6734">
                                Quarterly
                              </div>
                              <div className={`font-bold ${consolidatedStock.trend.quarterly.startsWith('+') ? 'text-green-600' : 'text-red-600'}`} data-id="element-6735">
                                {consolidatedStock.trend.quarterly}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="border-t border-blue-100 p-3 bg-gradient-to-r from-blue-50 to-indigo-50 flex justify-between items-center" data-id="element-6736">
                      <button className="text-indigo-600 hover:text-indigo-800 hover:bg-white/50 font-medium flex items-center py-2 px-4 rounded-lg transition-colors" data-id="element-6737">
                        <FileTextIcon size={16} className="mr-2" data-id="element-6738" />
                        Generate Report
                      </button>
                      <div className="flex space-x-2" data-id="element-6739">
                        <button className="text-indigo-600 hover:text-indigo-800 hover:bg-white/50 font-medium flex items-center py-2 px-4 rounded-lg transition-colors" data-id="element-6740">
                          <EyeIcon size={16} className="mr-2" data-id="element-6741" />
                          View Details
                        </button>
                        <button className="text-gray-600 hover:text-gray-800 hover:bg-white/50 font-medium flex items-center py-2 px-4 rounded-lg transition-colors" data-id="element-6742">
                          <SettingsIcon size={16} className="mr-2" data-id="element-6743" />
                          Configure
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                {/* Machine stock cards - enhanced grid */}
                <div className="p-6 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 bg-gradient-to-br from-white to-blue-50" data-id="element-6744">
                  {filteredMachines.map(machine => <MachineStockCard key={machine.id} machine={machine} data-id="element-6745" />)}
                </div>
                {/* Pagination */}
                <div className="p-6 border-t border-gray-200 bg-gradient-to-r from-gray-50 to-blue-50 flex justify-between items-center" data-id="element-6746">
                  <div className="text-sm text-gray-600" data-id="element-6747">
                    Showing{' '}
                    <span className="font-medium" data-id="element-6748">
                      {filteredMachines.length}
                    </span>{' '}
                    of{' '}
                    <span className="font-medium" data-id="element-6749">
                      {machineStockData.length}
                    </span>{' '}
                    machines
                  </div>
                  <div className="flex space-x-1" data-id="element-6750">
                    <button className="px-3 py-1 border border-gray-300 rounded-md text-gray-600 hover:bg-white" data-id="element-6751">
                      &laquo;
                    </button>
                    <button className="px-3 py-1 border border-gray-300 rounded-md bg-indigo-100 text-indigo-700 font-medium" data-id="element-6752">
                      1
                    </button>
                    <button className="px-3 py-1 border border-gray-300 rounded-md text-gray-600 hover:bg-white" data-id="element-6753">
                      &raquo;
                    </button>
                  </div>
                </div>
              </>}
            {activeStockTab === 'stockInTransit' && <div className="p-8 flex items-center justify-center" data-id="element-6754">
                <div className="text-center" data-id="element-6755">
                  <TruckIcon size={48} className="mx-auto text-indigo-400 mb-4" data-id="element-6756" />
                  <h3 className="text-xl font-medium text-gray-800 mb-2" data-id="element-6757">
                    Stock in Transit
                  </h3>
                  <p className="text-gray-600" data-id="element-6758">
                    This section will show machines that are currently in
                    transit to this warehouse.
                  </p>
                </div>
              </div>}
            {/* Create Stock Template Modal */}
            {showStockTemplateModal && <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50" data-id="element-6759">
                <div className="bg-white rounded-xl shadow-2xl w-full max-w-2xl mx-4 animate-fadeIn" data-id="element-6760">
                  <div className="p-5 border-b border-gray-200 flex justify-between items-center bg-gradient-to-r from-blue-50 to-indigo-50" data-id="element-6761">
                    <h3 className="text-lg font-bold text-gray-800 flex items-center" data-id="element-6762">
                      <PlusIcon size={18} className="mr-2 text-indigo-600" data-id="element-6763" />
                      Create Stock Template
                    </h3>
                    <button className="text-gray-500 hover:text-gray-700" onClick={() => setShowStockTemplateModal(false)} data-id="element-6764">
                      <XCircleIcon size={20} data-id="element-6765" />
                    </button>
                  </div>
                  <div className="p-5" data-id="element-6766">
                    <div className="mb-4" data-id="element-6767">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6768">
                        Template Name
                      </label>
                      <input type="text" placeholder="Enter template name..." className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6769" />
                    </div>
                    <div className="mb-4" data-id="element-6770">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6771">
                        Description
                      </label>
                      <textarea placeholder="Enter template description..." rows={3} className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6772"></textarea>
                    </div>
                    <div className="mb-4" data-id="element-6773">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6774">
                        Machine Type
                      </label>
                      <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6775">
                        <option data-id="element-6776">Pivot Machine</option>
                        <option data-id="element-6777">Linear</option>
                        <option data-id="element-6778">Pivot Accessory</option>
                      </select>
                    </div>
                    <div className="grid grid-cols-2 gap-4 mb-4" data-id="element-6779">
                      <div data-id="element-6780">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6781">
                          Desired Stock
                        </label>
                        <input type="number" placeholder="0" className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6782" />
                      </div>
                      <div data-id="element-6783">
                        <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6784">
                          Priority
                        </label>
                        <select className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500" data-id="element-6785">
                          <option data-id="element-6786">High</option>
                          <option data-id="element-6787">Medium</option>
                          <option data-id="element-6788">Low</option>
                        </select>
                      </div>
                    </div>
                    <div className="mb-4" data-id="element-6789">
                      <label className="block text-sm font-medium text-gray-700 mb-1" data-id="element-6790">
                        Tags
                      </label>
                      <div className="flex flex-wrap gap-2 p-2 border border-gray-300 rounded-lg" data-id="element-6791">
                        <div className="bg-indigo-100 text-indigo-800 px-2 py-1 rounded-md text-sm flex items-center" data-id="element-6792">
                          Irrigation
                          <XCircleIcon size={14} className="ml-1 cursor-pointer" data-id="element-6793" />
                        </div>
                        <input type="text" placeholder="Add tag..." className="flex-1 border-0 focus:outline-none text-sm" data-id="element-6794" />
                      </div>
                    </div>
                  </div>
                  <div className="p-5 border-t border-gray-200 flex justify-end gap-3 bg-gradient-to-r from-gray-50 to-blue-50" data-id="element-6795">
                    <button className="px-4 py-2 text-gray-700 border border-gray-300 rounded-lg hover:bg-gray-100" onClick={() => setShowStockTemplateModal(false)} data-id="element-6796">
                      Cancel
                    </button>
                    <button className="px-4 py-2 bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 text-white rounded-lg shadow-md" onClick={() => setShowStockTemplateModal(false)} data-id="element-6797">
                      Create Template
                    </button>
                  </div>
                </div>
              </div>}
          </div>}
        {activeTab === 'inventory' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6798">
            <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6799">
              <h2 className="text-xl font-bold flex items-center text-indigo-800" data-id="element-6800">
                <BoxIcon size={22} className="mr-3 text-indigo-600" data-id="element-6801" />
                Inventory Management
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-6802">
                View and manage all inventory items in this warehouse
              </p>
            </div>
            {/* Toolbar with improved styling */}
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 p-5 border-b border-gray-100 flex flex-wrap items-center justify-between gap-4" data-id="element-6803">
              <div className="relative" data-id="element-6804">
                <input type="text" placeholder="Search inventory..." className="pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 w-64 shadow-sm" data-id="element-6805" />
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-6806" />
              </div>
              <div className="flex gap-3" data-id="element-6807">
                <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2.5 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6808">
                  <FilterIcon size={16} className="mr-2" data-id="element-6809" />
                  Filter
                </button>
                <button className="flex items-center text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 px-4 py-2.5 rounded-lg transition-all shadow-md hover:shadow-lg" data-id="element-6810">
                  <PlusIcon size={16} className="mr-2" data-id="element-6811" />
                  Add Item
                </button>
              </div>
            </div>
            {/* Inventory categories with improved styling */}
            <div className="p-6 md:p-8 space-y-6" data-id="element-6812">
              {inventoryData.map((category, index) => <div key={index} className="border border-gray-200 rounded-xl overflow-hidden shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6813">
                  <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-5 py-3.5 flex justify-between items-center cursor-pointer hover:bg-gradient-to-r hover:from-gray-100 hover:to-blue-100" data-id="element-6814">
                    <h3 className="font-medium text-gray-800 flex items-center" data-id="element-6815">
                      <BoxIcon size={18} className="mr-2 text-indigo-600" data-id="element-6816" />
                      {category.category}
                    </h3>
                    <ChevronDownIcon size={20} className="text-gray-500" data-id="element-6817" />
                  </div>
                  <div className="overflow-x-auto" data-id="element-6818">
                    <table className="w-full" data-id="element-6819">
                      <thead className="bg-gradient-to-r from-gray-50 to-indigo-50" data-id="element-6820">
                        <tr data-id="element-6821">
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6822">
                            ID
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6823">
                            Item Name
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6824">
                            Quantity
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6825">
                            Unit
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6826">
                            Status
                          </th>
                          <th className="px-6 py-3.5 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-6827">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-gray-200 bg-white" data-id="element-6828">
                        {category.items.map(item => <tr key={item.id} className="hover:bg-blue-50 transition-colors" data-id="element-6829">
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-6830">
                              {item.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700" data-id="element-6831">
                              {item.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-700 font-medium" data-id="element-6832">
                              {item.quantity}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-6833">
                              {item.unit}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap" data-id="element-6834">
                              <StatusBadge status={item.status} data-id="element-6835" />
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm" data-id="element-6836">
                              <button className="text-indigo-600 hover:text-indigo-800 mr-3 font-medium" data-id="element-6837">
                                Edit
                              </button>
                              <button className="text-indigo-600 hover:text-indigo-800 font-medium" data-id="element-6838">
                                History
                              </button>
                            </td>
                          </tr>)}
                      </tbody>
                    </table>
                  </div>
                </div>)}
            </div>
            {/* Summary cards with improved styling */}
            <div className="px-8 pb-8 grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-6839">
              <div className="bg-gradient-to-br from-blue-50 via-blue-100 to-indigo-100 border border-blue-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6840">
                <div className="flex items-center justify-between mb-3" data-id="element-6841">
                  <h4 className="text-indigo-800 font-medium" data-id="element-6842">Total Items</h4>
                  <div className="bg-gradient-to-br from-blue-200 to-indigo-300 p-1.5 rounded-full" data-id="element-6843">
                    <BoxIcon size={18} className="text-indigo-700" data-id="element-6844" />
                  </div>
                </div>
                <p className="text-4xl font-bold text-indigo-700 mt-2" data-id="element-6845">267</p>
                <p className="text-indigo-600 text-sm mt-1 flex items-center" data-id="element-6846">
                  <InfoIcon size={14} className="mr-1" data-id="element-6847" />
                  Across all categories
                </p>
              </div>
              <div className="bg-gradient-to-br from-amber-50 via-amber-100 to-orange-100 border border-amber-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6848">
                <div className="flex items-center justify-between mb-3" data-id="element-6849">
                  <h4 className="text-amber-800 font-medium" data-id="element-6850">
                    Low Stock Items
                  </h4>
                  <div className="bg-gradient-to-br from-amber-200 to-orange-300 p-1.5 rounded-full" data-id="element-6851">
                    <AlertCircleIcon size={18} className="text-amber-700" data-id="element-6852" />
                  </div>
                </div>
                <p className="text-4xl font-bold text-amber-700 mt-2" data-id="element-6853">14</p>
                <p className="text-amber-600 text-sm mt-1 flex items-center" data-id="element-6854">
                  <InfoIcon size={14} className="mr-1" data-id="element-6855" />
                  Require attention
                </p>
              </div>
              <div className="bg-gradient-to-br from-red-50 via-red-100 to-rose-100 border border-red-200 rounded-xl p-5 shadow-md hover:shadow-lg transition-all duration-300" data-id="element-6856">
                <div className="flex items-center justify-between mb-3" data-id="element-6857">
                  <h4 className="text-red-800 font-medium" data-id="element-6858">Out of Stock</h4>
                  <div className="bg-gradient-to-br from-red-200 to-rose-300 p-1.5 rounded-full" data-id="element-6859">
                    <XCircleIcon size={18} className="text-red-700" data-id="element-6860" />
                  </div>
                </div>
                <p className="text-4xl font-bold text-red-700 mt-2" data-id="element-6861">3</p>
                <p className="text-red-600 text-sm mt-1 flex items-center" data-id="element-6862">
                  <InfoIcon size={14} className="mr-1" data-id="element-6863" />
                  Need immediate reorder
                </p>
              </div>
            </div>
          </div>}
        {activeTab === 'alterations' && <div className="bg-gradient-to-br from-white to-blue-50 text-gray-800 rounded-xl shadow-2xl overflow-hidden transition-all duration-500" data-id="element-6864">
            <div className="p-6 border-b border-gray-100 bg-gradient-to-r from-blue-100 via-indigo-50 to-white" data-id="element-6865">
              <h2 className="text-xl font-bold flex items-center text-indigo-800" data-id="element-6866">
                <HistoryIcon size={22} className="mr-3 text-indigo-600" data-id="element-6867" />
                Alterations History
              </h2>
              <p className="text-gray-500 mt-1" data-id="element-6868">
                Track all changes and updates made to this warehouse
              </p>
            </div>
            {/* Toolbar with improved styling */}
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 p-5 border-b border-gray-100 flex flex-wrap items-center justify-between gap-4" data-id="element-6869">
              <div className="relative" data-id="element-6870">
                <input type="text" placeholder="Search alterations..." className="pl-10 pr-4 py-2.5 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 w-64 shadow-sm" data-id="element-6871" />
                <SearchIcon size={18} className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" data-id="element-6872" />
              </div>
              <div className="flex gap-3" data-id="element-6873">
                <button className="flex items-center text-gray-700 border border-gray-300 px-4 py-2.5 rounded-lg hover:bg-gray-100 transition-all shadow-sm" data-id="element-6874">
                  <FilterIcon size={16} className="mr-2" data-id="element-6875" />
                  Filter
                </button>
                <button className="flex items-center text-white bg-gradient-to-r from-blue-600 to-indigo-600 hover:from-blue-700 hover:to-indigo-700 px-4 py-2.5 rounded-lg transition-all shadow-md hover:shadow-lg" data-id="element-6876">
                  <DownloadIcon size={16} className="mr-2" data-id="element-6877" />
                  Export History
                </button>
              </div>
            </div>
            {/* Timeline with improved styling */}
            <div className="p-6 md:p-8" data-id="element-6878">
              <div className="space-y-8" data-id="element-6879">
                {alterationsData.map((alteration, index) => <div key={alteration.id} className="flex" data-id="element-6880">
                    <div className="relative" data-id="element-6881">
                      <div className="flex-shrink-0 w-12 h-12 rounded-full bg-gradient-to-br from-blue-100 to-indigo-200 flex items-center justify-center shadow-md z-10 relative" data-id="element-6882">
                        <HistoryIcon size={22} className="text-indigo-600" data-id="element-6883" />
                      </div>
                      {index < alterationsData.length - 1 && <div className="absolute top-12 bottom-0 left-1/2 w-0.5 bg-gradient-to-b from-indigo-200 to-blue-100 -ml-px h-full" data-id="element-6884"></div>}
                    </div>
                    <div className="ml-6 flex-1 bg-gradient-to-br from-white to-blue-50 rounded-xl border border-gray-100 shadow-md hover:shadow-lg transition-all duration-300 overflow-hidden" data-id="element-6885">
                      <div className="p-5 border-b border-gray-50" data-id="element-6886">
                        <div className="flex items-center justify-between" data-id="element-6887">
                          <h3 className="text-lg font-medium text-gray-900 flex items-center" data-id="element-6888">
                            {alteration.type}
                            <span className="ml-3 bg-gradient-to-r from-blue-100 to-indigo-100 text-indigo-700 text-xs px-2.5 py-0.5 rounded-full" data-id="element-6889">
                              #{alteration.id}
                            </span>
                          </h3>
                          <div className="flex items-center text-sm text-gray-500 bg-gradient-to-r from-gray-50 to-blue-50 px-3 py-1 rounded-full" data-id="element-6890">
                            <CalendarIcon size={14} className="mr-1.5" data-id="element-6891" />
                            {alteration.date}
                          </div>
                        </div>
                        <p className="mt-3 text-gray-600" data-id="element-6892">
                          {alteration.description}
                        </p>
                        <div className="mt-4 flex items-center text-sm text-gray-500 bg-gradient-to-r from-gray-50 to-blue-50 inline-block px-3 py-1 rounded-full" data-id="element-6893">
                          <UserIcon size={14} className="mr-1.5" data-id="element-6894" />
                          By: {alteration.user}
                        </div>
                      </div>
                      <div className="px-5 py-2.5 bg-gradient-to-r from-gray-50 to-blue-50 flex justify-end" data-id="element-6895">
                        <button className="text-indigo-600 hover:text-indigo-800 text-sm font-medium flex items-center" data-id="element-6896">
                          View Details
                          <ArrowRightIcon size={14} className="ml-1" data-id="element-6897" />
                        </button>
                      </div>
                    </div>
                  </div>)}
              </div>
            </div>
            {/* Load more with improved styling */}
            <div className="bg-gradient-to-r from-gray-50 to-blue-50 px-8 py-5 text-center border-t border-gray-100" data-id="element-6898">
              <button className="text-indigo-600 hover:text-indigo-800 font-medium flex items-center justify-center mx-auto bg-gradient-to-r from-white to-blue-50 px-5 py-2.5 rounded-lg border border-blue-200 shadow-sm hover:shadow-md transition-all" data-id="element-6899">
                <RefreshCwIcon size={16} className="mr-2" data-id="element-6900" />
                Load More History
              </button>
            </div>
          </div>}
      </div>
    </div>;
}
// Helper component for tab buttons
function TabButton({
  icon,
  label,
  active,
  onClick
}) {
  return <button className={`px-6 py-3.5 font-medium flex items-center transition-all duration-300 ${active ? 'border-b-2 border-white text-white' : 'text-gray-300 hover:text-white hover:bg-white/5'}`} onClick={onClick} data-id="element-6901">
      {icon && <span className="mr-2" data-id="element-6902">{icon}</span>}
      {label}
    </button>;
}
// Helper component for stock tab buttons
function StockTabButton({
  label,
  active,
  onClick
}) {
  return <button className={`px-6 py-3.5 font-medium transition-all duration-300 ${active ? 'border-b-2 border-indigo-500 text-indigo-600 bg-gradient-to-r from-blue-50 to-indigo-50' : 'text-gray-600 hover:text-gray-800 hover:bg-gradient-to-r hover:from-gray-50 hover:to-blue-50'}`} onClick={onClick} data-id="element-6903">
      {label}
    </button>;
}
// Helper component for detail rows
function DetailRow({
  icon,
  label,
  value
}) {
  return <div className="flex border-b border-gray-100 pb-4 hover:bg-gradient-to-r hover:from-gray-50 hover:to-blue-50 p-2 rounded-lg transition-colors" data-id="element-6904">
      <div className="w-48 font-medium flex items-center text-gray-700" data-id="element-6905">
        {icon && <span className="mr-2" data-id="element-6906">{icon}</span>}
        {typeof label === 'string' ? label : label}
      </div>
      <div className="flex-1 font-medium text-gray-900" data-id="element-6907">{value}</div>
    </div>;
}
// Helper component for status badges
function StatusBadge({
  status
}) {
  let config = {
    color: 'gray',
    icon: null
  };
  if (status === 'In Stock' || status === 'Optimal') {
    config = {
      color: 'green',
      icon: <CheckCircleIcon size={14} className="mr-1" data-id="element-6908" />
    };
  } else if (status === 'Low Stock' || status === 'Low') {
    config = {
      color: 'amber',
      icon: <AlertCircleIcon size={14} className="mr-1" data-id="element-6909" />
    };
  } else if (status === 'Out of Stock') {
    config = {
      color: 'red',
      icon: <XCircleIcon size={14} className="mr-1" data-id="element-6910" />
    };
  }
  const gradients = {
    green: 'bg-gradient-to-r from-green-100 to-emerald-100',
    amber: 'bg-gradient-to-r from-amber-100 to-yellow-100',
    red: 'bg-gradient-to-r from-red-100 to-rose-100',
    gray: 'bg-gradient-to-r from-gray-100 to-slate-100'
  };
  const textColors = {
    green: 'text-green-800',
    amber: 'text-amber-800',
    red: 'text-red-800',
    gray: 'text-gray-800'
  };
  return <span className={`inline-flex items-center px-2.5 py-1 rounded-full text-xs font-medium ${gradients[config.color]} ${textColors[config.color]}`} data-id="element-6911">
      {config.icon}
      {status}
    </span>;
}
// Helper component for stock stat items with colored dots
function StockStatItem({
  color,
  label
}) {
  const colors = {
    yellow: 'bg-gradient-to-r from-yellow-500 to-amber-500',
    orange: 'bg-gradient-to-r from-orange-500 to-amber-600',
    green: 'bg-gradient-to-r from-green-500 to-emerald-500',
    red: 'bg-gradient-to-r from-red-500 to-rose-500'
  };
  return <div className="flex items-center" data-id="element-6912">
      <div className={`h-3 w-3 rounded-full ${colors[color]} mr-2.5 shadow-sm`} data-id="element-6913"></div>
      <span className="text-sm font-medium text-gray-700" data-id="element-6914">{label}</span>
    </div>;
}
// Enhanced version of StockStatItem with value and icon
function StockStatItemEnhanced({
  color,
  label,
  value,
  icon
}) {
  const colors = {
    yellow: {
      dot: 'bg-gradient-to-r from-yellow-500 to-amber-500',
      text: 'text-amber-700',
      bg: 'bg-gradient-to-r from-yellow-50 to-amber-100'
    },
    orange: {
      dot: 'bg-gradient-to-r from-orange-500 to-amber-600',
      text: 'text-amber-700',
      bg: 'bg-gradient-to-r from-orange-50 to-amber-100'
    },
    green: {
      dot: 'bg-gradient-to-r from-green-500 to-emerald-500',
      text: 'text-green-700',
      bg: 'bg-gradient-to-r from-green-50 to-emerald-100'
    },
    red: {
      dot: 'bg-gradient-to-r from-red-500 to-rose-500',
      text: 'text-red-700',
      bg: 'bg-gradient-to-r from-red-50 to-rose-100'
    }
  };
  const colorConfig = colors[color];
  return <div className={`flex items-center justify-between py-2 px-3 rounded-lg ${colorConfig.bg}`} data-id="element-6915">
      <div className="flex items-center" data-id="element-6916">
        <div className={`h-3 w-3 rounded-full ${colorConfig.dot} mr-2.5 shadow-sm`} data-id="element-6917"></div>
        <span className="text-sm font-medium text-gray-800" data-id="element-6918">{label}</span>
      </div>
      <div className={`flex items-center ${colorConfig.text} font-medium`} data-id="element-6919">
        {icon && <span className="mr-1" data-id="element-6920">{icon}</span>}
        {value}
      </div>
    </div>;
}
// Helper component for stock progress bars
function StockProgressBar({
  label,
  value,
  color
}) {
  const colors = {
    yellow: {
      bg: 'bg-gradient-to-r from-yellow-50 to-amber-100',
      fill: 'bg-gradient-to-r from-yellow-400 to-amber-500',
      text: 'text-amber-800'
    },
    orange: {
      bg: 'bg-gradient-to-r from-orange-50 to-amber-100',
      fill: 'bg-gradient-to-r from-orange-400 to-amber-500',
      text: 'text-orange-800'
    },
    green: {
      bg: 'bg-gradient-to-r from-green-50 to-emerald-100',
      fill: 'bg-gradient-to-r from-green-400 to-emerald-500',
      text: 'text-green-800'
    },
    red: {
      bg: 'bg-gradient-to-r from-red-50 to-rose-100',
      fill: 'bg-gradient-to-r from-red-400 to-rose-500',
      text: 'text-red-800'
    }
  };
  const colorConfig = colors[color];
  return <div className="space-y-1" data-id="element-6921">
      <div className="flex justify-between items-center" data-id="element-6922">
        <span className="text-xs font-medium text-gray-700" data-id="element-6923">{label}</span>
        <span className={`text-xs font-medium ${colorConfig.text}`} data-id="element-6924">
          {value}%
        </span>
      </div>
      <div className={`w-full h-2 ${colorConfig.bg} rounded-full overflow-hidden`} data-id="element-6925">
        <div className={`h-full ${colorConfig.fill} rounded-full`} style={{
        width: `${value}%`
      }} data-id="element-6926"></div>
      </div>
    </div>;
}
// Helper component for filter buttons
function FilterButton({
  label,
  active,
  onClick,
  count,
  color = 'indigo'
}) {
  const colors = {
    indigo: {
      activeBg: 'bg-gradient-to-r from-indigo-500 to-blue-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-indigo-50',
      inactiveText: 'text-gray-700 hover:text-indigo-700',
      countBg: 'bg-indigo-100',
      countText: 'text-indigo-800'
    },
    red: {
      activeBg: 'bg-gradient-to-r from-red-500 to-rose-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-red-50',
      inactiveText: 'text-gray-700 hover:text-red-700',
      countBg: 'bg-red-100',
      countText: 'text-red-800'
    },
    amber: {
      activeBg: 'bg-gradient-to-r from-amber-500 to-orange-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-amber-50',
      inactiveText: 'text-gray-700 hover:text-amber-700',
      countBg: 'bg-amber-100',
      countText: 'text-amber-800'
    },
    green: {
      activeBg: 'bg-gradient-to-r from-green-500 to-emerald-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-green-50',
      inactiveText: 'text-gray-700 hover:text-green-700',
      countBg: 'bg-green-100',
      countText: 'text-green-800'
    },
    blue: {
      activeBg: 'bg-gradient-to-r from-blue-500 to-sky-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-blue-50',
      inactiveText: 'text-gray-700 hover:text-blue-700',
      countBg: 'bg-blue-100',
      countText: 'text-blue-800'
    },
    gray: {
      activeBg: 'bg-gradient-to-r from-gray-500 to-slate-600',
      activeText: 'text-white',
      inactiveBg: 'bg-white hover:bg-gray-50',
      inactiveText: 'text-gray-700 hover:text-gray-700',
      countBg: 'bg-gray-100',
      countText: 'text-gray-800'
    }
  };
  const colorConfig = colors[color];
  return <button className={`flex items-center justify-between px-4 py-2 rounded-lg border transition-all ${active ? `${colorConfig.activeBg} border-transparent ${colorConfig.activeText} shadow-md` : `${colorConfig.inactiveBg} border-gray-300 ${colorConfig.inactiveText}`}`} onClick={onClick} data-id="element-6927">
      <span className="font-medium" data-id="element-6928">{label}</span>
      <span className={`ml-2 inline-flex items-center justify-center h-5 w-5 text-xs rounded-full ${active ? 'bg-white/20 text-white' : `${colorConfig.countBg} ${colorConfig.countText}`}`} data-id="element-6929">
        {count}
      </span>
    </button>;
}
// Helper component for sort options
function SortOption({
  label,
  active,
  onClick
}) {
  return <button className={`w-full text-left px-4 py-2 text-sm ${active ? 'bg-indigo-50 text-indigo-700 font-medium' : 'text-gray-700 hover:bg-gray-50'}`} onClick={onClick} data-id="element-6930">
      <div className="flex items-center" data-id="element-6931">
        {active && <CheckIcon size={14} className="mr-2 text-indigo-600" data-id="element-6932" />}
        <span className={active ? 'ml-0' : 'ml-5'} data-id="element-6933">{label}</span>
      </div>
    </button>;
}
// Shopping cart icon component
function ShoppingCartIcon({
  size,
  className
}) {
  return <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className={className} data-id="element-6934">
      <circle cx="8" cy="21" r="1" data-id="element-6935" />
      <circle cx="19" cy="21" r="1" data-id="element-6936" />
      <path d="M2.05 2.05h2l2.66 12.42a2 2 0 0 0 2 1.58h9.78a2 2 0 0 0 1.95-1.57l1.65-7.43H5.12" data-id="element-6937" />
    </svg>;
}
// Machine Stock Card component
function MachineStockCard({
  machine
}) {
  const statusConfig = {
    Critical: {
      bg: 'bg-gradient-to-r from-red-50 to-rose-100',
      border: 'border-red-200',
      badge: 'bg-gradient-to-r from-red-500 to-rose-600 text-white',
      icon: <AlertCircleIcon size={16} className="mr-1 text-white" data-id="element-6938" />
    },
    Warning: {
      bg: 'bg-gradient-to-r from-amber-50 to-yellow-100',
      border: 'border-amber-200',
      badge: 'bg-gradient-to-r from-amber-500 to-yellow-600 text-white',
      icon: <AlertCircleIcon size={16} className="mr-1 text-white" data-id="element-6939" />
    },
    Good: {
      bg: 'bg-gradient-to-r from-blue-50 to-indigo-100',
      border: 'border-blue-200',
      badge: 'bg-gradient-to-r from-blue-500 to-indigo-600 text-white',
      icon: <CheckCircleIcon size={16} className="mr-1 text-white" data-id="element-6940" />
    },
    Optimal: {
      bg: 'bg-gradient-to-r from-green-50 to-emerald-100',
      border: 'border-green-200',
      badge: 'bg-gradient-to-r from-green-500 to-emerald-600 text-white',
      icon: <CheckCircleIcon size={16} className="mr-1 text-white" data-id="element-6941" />
    }
  };
  const priorityConfig = {
    High: {
      bg: 'bg-red-100',
      text: 'text-red-800'
    },
    Medium: {
      bg: 'bg-amber-100',
      text: 'text-amber-800'
    },
    Low: {
      bg: 'bg-blue-100',
      text: 'text-blue-800'
    }
  };
  const trendConfig = {
    increasing: {
      icon: <TrendingUpIcon size={14} className="mr-1 text-green-600" data-id="element-6942" />,
      text: 'text-green-600'
    },
    decreasing: {
      icon: <TrendingDownIcon size={14} className="mr-1 text-red-600" data-id="element-6943" />,
      text: 'text-red-600'
    },
    stable: {
      icon: <ArrowRightIcon size={14} className="mr-1 text-blue-600" data-id="element-6944" />,
      text: 'text-blue-600'
    }
  };
  const config = statusConfig[machine.status];
  const priorityConf = priorityConfig[machine.priority];
  const trendConf = trendConfig[machine.trend];
  return <div className={`rounded-xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300 ${config.bg} ${config.border}`} data-id="element-6945">
      <div className="p-5 relative" data-id="element-6946">
        <div className="flex justify-between items-start mb-3" data-id="element-6947">
          <div data-id="element-6948">
            <div className="flex items-center mb-1" data-id="element-6949">
              <span className={`px-2.5 py-1 rounded-full text-xs font-medium flex items-center ${config.badge}`} data-id="element-6950">
                {config.icon}
                {machine.status}
              </span>
              <span className={`ml-2 px-2 py-0.5 rounded-full text-xs font-medium ${priorityConf.bg} ${priorityConf.text}`} data-id="element-6951">
                {machine.priority} Priority
              </span>
            </div>
            <h3 className="font-bold text-xl text-gray-800" data-id="element-6952">{machine.name}</h3>
            <div className="flex items-center mt-1 text-gray-600 text-sm" data-id="element-6953">
              <TagIcon size={14} className="mr-1" data-id="element-6954" />
              {machine.type}
              <span className="mx-2" data-id="element-6955">•</span>
              <span className="text-xs bg-gray-100 px-2 py-0.5 rounded-full" data-id="element-6956">
                {machine.id}
              </span>
            </div>
          </div>
          <div className="bg-white/80 backdrop-blur-sm p-2 rounded-lg border border-gray-200 shadow-sm" data-id="element-6957">
            <div className="text-center" data-id="element-6958">
              <div className="text-xs text-gray-500" data-id="element-6959">Desired</div>
              <div className="text-lg font-bold text-indigo-700" data-id="element-6960">
                {machine.desiredStock}
              </div>
            </div>
          </div>
        </div>
        <div className="mt-4 space-y-3" data-id="element-6961">
          {Object.entries(machine.stats).map(([key, value]) => {
          if (value === 0) return null;
          const label = key.replace(/([A-Z])/g, ' $1').replace(/^./, str => str.toUpperCase());
          let color = 'green';
          if (key === 'lowStock') color = 'yellow';
          if (key === 'overStock') color = 'orange';
          if (key === 'orderRequired') color = 'red';
          return <StockProgressBar key={key} label={label} value={value} color={color} data-id="element-6962" />;
        })}
        </div>
        <div className="mt-5 grid grid-cols-2 gap-4 text-sm" data-id="element-6963">
          <div className="bg-white rounded-lg p-3 border border-gray-100 shadow-sm" data-id="element-6964">
            <div className="font-medium text-gray-700 mb-1" data-id="element-6965">At hand:</div>
            <div className="text-lg font-bold text-indigo-700" data-id="element-6966">
              {machine.atHand}
            </div>
          </div>
          <div className="bg-white rounded-lg p-3 border border-gray-100 shadow-sm" data-id="element-6967">
            <div className="font-medium text-gray-700 mb-1" data-id="element-6968">Incoming:</div>
            <div className="text-lg font-bold text-teal-600" data-id="element-6969">
              {machine.incoming}
            </div>
          </div>
        </div>
        <div className="mt-4 flex items-center justify-between" data-id="element-6970">
          <div className="text-sm flex items-center" data-id="element-6971">
            <CalendarIcon size={14} className="mr-1 text-gray-500" data-id="element-6972" />
            <span className="text-gray-600" data-id="element-6973">
              Updated: {machine.lastUpdated}
            </span>
          </div>
          <div className={`text-sm flex items-center ${trendConf.text}`} data-id="element-6974">
            {trendConf.icon}
            <span data-id="element-6975">Trend: {machine.trend}</span>
          </div>
        </div>
        <div className="mt-3 p-3 bg-white/60 backdrop-blur-sm rounded-lg border border-gray-200 text-sm text-gray-700" data-id="element-6976">
          <InfoIcon size={14} className="inline-block mr-1 text-indigo-600" data-id="element-6977" />
          {machine.forecast}
        </div>
      </div>
      <div className="border-t border-gray-200 p-2 flex justify-between bg-white/60 backdrop-blur-sm" data-id="element-6978">
        <button className="text-indigo-600 hover:text-indigo-800 font-medium flex items-center py-1.5 px-4 rounded-md hover:bg-white transition-colors" data-id="element-6979">
          <EyeIcon size={16} className="mr-2" data-id="element-6980" />
          View
        </button>
        <div className="flex" data-id="element-6981">
          <button className="text-gray-600 hover:text-gray-800 font-medium flex items-center py-1.5 px-4 rounded-md hover:bg-white transition-colors" data-id="element-6982">
            <EditIcon size={16} className="mr-2" data-id="element-6983" />
            Edit
          </button>
          <button className="text-gray-500 hover:text-gray-700 font-medium flex items-center py-1.5 px-3 rounded-md hover:bg-white transition-colors ml-1" data-id="element-6984">
            <SettingsIcon size={16} data-id="element-6985" />
          </button>
        </div>
      </div>
    </div>;
}